import React from "react";

const Screeners = () => {
  return <div>Screeners</div>;
};

export default Screeners;
